import { render, staticRenderFns } from "./PcHorizontalTabs.vue?vue&type=template&id=17336c32"
import script from "./PcHorizontalTabs.vue?vue&type=script&lang=js"
export * from "./PcHorizontalTabs.vue?vue&type=script&lang=js"
import style0 from "./PcHorizontalTabs.vue?vue&type=style&index=0&id=17336c32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VWindow } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCol,VContainer,VRow,VTab,VTabs,VWindow})
